import { render } from "./HomePart9.vue?vue&type=template&id=57bcd611&scoped=true&ts=true"
import script from "./HomePart9.vue?vue&type=script&lang=ts"
export * from "./HomePart9.vue?vue&type=script&lang=ts"

import "./HomePart9.vue?vue&type=style&index=0&id=57bcd611&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bcd611"]])

export default __exports__